import { render, staticRenderFns } from "./reviewcase.vue?vue&type=template&id=21072074&scoped=true&"
import script from "./reviewcase.vue?vue&type=script&lang=js&"
export * from "./reviewcase.vue?vue&type=script&lang=js&"
import style0 from "./reviewcase.vue?vue&type=style&index=0&id=21072074&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21072074",
  null
  
)

export default component.exports